export default "__VITE_ASSET__BqGe50nP__"